import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { PublishingStatus } from '../../models/serializable/publishing-status.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PublishingStatusComponent extends Component {
  static readonly TYPE_ID: string = 'd250c8c6f3f744488b8c54972758cbcf';

  constructor(
    public readonly publishingStatus: PublishingStatus,
  ) {
    super();
  }

  get $typeId(): string {
    return PublishingStatusComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PublishingStatusComponent {
    return new PublishingStatusComponent(
        MapUtils.get<PublishingStatus>(map, 'publishingStatus'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'publishingStatus': this.publishingStatus,
    };
  }

  clone(): this {
    return new PublishingStatusComponent(this.publishingStatus) as this;
  }

  isSame(other: PublishingStatusComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.publishingStatus === this.publishingStatus;
  }
}

export class PublishingStatusComponentBuilder extends DataModelBuilder<PublishingStatusComponent> {
  build(context: SerializationContext, map: SerializedData): PublishingStatusComponent {
    return PublishingStatusComponent.fromMap(context, map);
  }
}
